// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__rNtJR","head":"Table_head__3O0N3","col":"Table_col__2QhGG"};